import { useEffect } from 'react';
import { useLelyAuth } from '../../auth/useLelyAuth';

export const MOPINION_FORM_ID = 'deae9b878dbf0cc29172db58e9894a1190977207';

const useMopinion = () => {
  const { user, isLoading, isAuthenticated } = useLelyAuth();
  const isTestAccount = (user?.email || '').includes('ltda-test-account.com');

  useEffect(() => {
    if (isLoading || !isAuthenticated || isTestAccount) {
      return;
    }

    const script = document.createElement('script');
    script.src = '/mopinion.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      script.remove();
    };
  }, [isLoading, isAuthenticated, isTestAccount]);
};

export default useMopinion;
